import { writable } from 'svelte/store';

export const screen = writable(0);
export const feedbackType = writable("");
export const feedbackDetail = writable("");
export const name = writable("");
export const space = writable("");